// ===============================
// Options/suboptions linking logic
// ===============================
const main_media_element = document.querySelector('.customizer_media');
document.querySelectorAll(".customizer_optionBlock").forEach((optionBlock) => {
  const blockName =
    optionBlock.getAttribute("data-blockname") ||
    optionBlock.getAttribute("data-blockName");
  const mediaContainer = blockName ? document.getElementById(blockName) : null;
  if (!mediaContainer) return;

  const tabs = optionBlock.querySelectorAll(".customizer-tab");
  const contents = mediaContainer.querySelectorAll(".customizer-tab-content");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const targetId = tab.dataset.tab;
      const matchingContent = mediaContainer.querySelector(`#${targetId}`);

      if (matchingContent) {
        // show only this block’s media panel
        document
          .querySelectorAll(".option_media_block")
          .forEach((b) => b.classList.toggle("active", b.id === blockName));

        main_media_element.classList.add('active');

        // highlight clicked tab
        tabs.forEach((t) => t.classList.toggle("active", t === tab));

        // show matching content inside this media container
        contents.forEach((c) =>
          c.classList.toggle("active", c.id === targetId)
        );

        //matchingContent.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        // close media area if there’s no matching content (like a “disable” tab)
        document
          .querySelectorAll(".option_media_block")
          .forEach((b) => b.classList.remove("active"));

          main_media_element.classList.remove('active');

        tabs.forEach((t) => t.classList.toggle("active", t === tab));

        // update selection label and zero the price for this option block
        const summary = optionBlock.querySelector(".selected_opt_summay");
        if (summary) {
          const titleEl = summary.querySelector("p");
          if (titleEl) titleEl.textContent = tab.textContent.trim();
          const descEl = summary.querySelector("h5");
          if (descEl) descEl.textContent = "";
        }

        const optElem = optionBlock.querySelector("[data-option-price]");
        if (optElem) optElem.dataset.optionPrice = (0).toFixed(2);

        updateFooterSummary();
      }
    });
  });
});

// ======================
// Handle View button (vertical carousel using Swiper)
// ======================
document.querySelectorAll(".btn_view").forEach((button) => {
  button.addEventListener("click", (e) => {
    e.stopPropagation();

    const parentItem = button.closest(".customizer-tab-item");
    if (!parentItem) return;

    // Parse data-img (JSON array). If parsing fails, try to fallback to the background image.
    let imgs = [];
    const raw = parentItem.getAttribute("data-img") || "";

    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) imgs = parsed;
    } catch (_) {
      // ignore; we'll try a fallback below
    }

    // Fallback: extract from background-image if JSON missing/invalid
    if (!imgs.length) {
      const bg = parentItem.style.backgroundImage || "";
      const m = bg.match(/url\(["']?(.*?)["']?\)/i);
      if (m && m[1]) imgs = [m[1]];
    }

    if (!imgs.length) return;

    // Build overlay
    const overlay = document.createElement("div");
    overlay.className = "image-popup-overlay";

    const wrapper = document.createElement("div");
    wrapper.className = "image-popup-wrapper";

    const closeBtn = document.createElement("button");
    closeBtn.className = "image-popup-close";
    closeBtn.innerHTML = "&times;";

    // Swiper container
    const swiperEl = document.createElement("div");
    swiperEl.className = "swiper popup-swiper";
    // Give the popup slider a clear size (vertical swipers need an explicit height)
    swiperEl.style.width = "90vw";
    swiperEl.style.maxWidth = "900px";
    swiperEl.style.height = "90vh";

    const track = document.createElement("div");
    track.className = "swiper-wrapper";

    imgs.forEach((src) => {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";

      const img = document.createElement("img");
      img.src = src;
      img.alt = "Preview";
      img.className = "image-popup-img";

      slide.appendChild(img);
      track.appendChild(slide);
    });

    const pagination = document.createElement("div");
    pagination.className = "swiper-pagination";

    swiperEl.appendChild(track);
    swiperEl.appendChild(pagination);

    wrapper.appendChild(closeBtn);
    wrapper.appendChild(swiperEl);
    overlay.appendChild(wrapper);
    document.body.appendChild(overlay);

    // Show overlay
    requestAnimationFrame(() => overlay.classList.add("active"));
    document.body.style.overflow = "hidden";

    // Init Swiper (vertical, mousewheel, bullets)
    let popupSwiper;
    popupSwiper = new Swiper(swiperEl, {
      direction: "vertical",
      slidesPerView: 1,
      spaceBetween: 10,
      mousewheel: true,
      allowTouchMove: true,
      autoHeight: true,
      pagination: {
        el: pagination,
        clickable: true,
      },
    });

    // Close helpers
    const closePopup = () => {
      overlay.classList.remove("active");
      document.body.style.overflow = "";
      if (popupSwiper && popupSwiper.destroy) {
        popupSwiper.destroy(true, true);
      }
      setTimeout(() => overlay.remove(), 250);
    };

    closeBtn.addEventListener("click", closePopup);
    overlay.addEventListener("click", (evt) => {
      if (evt.target === overlay) closePopup();
    });
    document.addEventListener("keydown", function escListener(evt) {
      if (evt.key === "Escape") {
        closePopup();
        document.removeEventListener("keydown", escListener);
      }
    });
  });
});

// ========================
// Handle Select button
// ========================
document.querySelectorAll(".btn_select").forEach((button) => {
  button.addEventListener("click", (e) => {
    e.stopPropagation();
    const tabItem = button.closest(".customizer-tab-item");
    if (!tabItem) return;

    const title = tabItem.getAttribute("data-title");
    const price = tabItem.getAttribute("data-price");
    const description = tabItem.getAttribute("data-description");

    const mediaBlock = tabItem.closest(".option_media_block");
    if (!mediaBlock) return;

    const blockId = mediaBlock.id;
    if (!blockId) return;

    const targetBlock = document.querySelector(
      `[data-blockname="${blockId}"], [data-blockName="${blockId}"]`
    );
    if (!targetBlock) return;

    const summaryBox = targetBlock.querySelector(".selected_opt_summay");
    if (!summaryBox) return;

    const summaryTitle = summaryBox.querySelector("p.title");
    const summaryPrice = summaryBox.querySelector("h5");
    const summaryDescription = summaryBox.querySelector("p.description");

    if (summaryTitle) summaryTitle.textContent = title || "";
    if (summaryPrice && price != null) summaryPrice.textContent = `+€${price}`;
    if (summaryDescription) summaryDescription.innerHTML = description || " ";

    const optElem = targetBlock.querySelector("[data-option-price]");
    if (optElem && price != null) {
      optElem.dataset.optionPrice = parseFloat(price).toFixed(2);
    }

    mediaBlock.classList.remove("active");

    main_media_element.classList.remove('active');

    // const container = document.querySelector(".customizer-container");
    // if (targetBlock) {
    //   targetBlock.scrollIntoView({ behavior: "smooth", block: "start" });
    // }

    updateFooterSummary();
  });
});

// =========================
// Handle Media Item click
// =========================
document.querySelectorAll(".customizer-tab-item").forEach((item) => {
  item.addEventListener("click", () => {
    const block = item.closest(".option_media_block");
    if (!block) return;

    block
      .querySelectorAll(".customizer-tab-item.selected")
      .forEach((i) => i.classList.remove("selected"));

    item.classList.add("selected");
  });
});

// ============================================
// update media height based on footer height
// ============================================

function updateElementHeight() {
    const footerBlock = document.querySelector('.customizer_footerBlock');
    const customizerContainers = document.querySelectorAll('.customizer_media, .customizer_media_wrap img, .option_media_block');
    
    if (footerBlock && customizerContainers.length > 0) {
        const footerHeight = footerBlock.offsetHeight;
        customizerContainers.forEach(container => {
            container.style.height = `calc(100vh - ${footerHeight}px)`;
        });
    }
}

// ==========================
// Footer summary + totals
// ==========================
function updateFooterSummary() {
  const parsePrice = (v) => {
    if (v == null) return 0;
    const n = parseFloat(
      String(v)
        .replace(",", ".")
        .replace(/[^\d.-]/g, "")
    );
    return isNaN(n) ? 0 : n;
  };

  let total = 0;

  const footerRows = Array.from(
    document.querySelectorAll(".customizer_summary_item .sum_optionTitle")
  );

  document
    .querySelectorAll(".customizer_optionBlock")
    .forEach((optionBlock) => {
      const h2 = optionBlock.querySelector(".customizer_optTitle h2");
      if (!h2) return;
      const heading = h2.textContent ? h2.textContent.trim() : "";

      // find selected display text
      let selectedText = "";
      const checked = optionBlock.querySelector('input[type="radio"]:checked');

      const summaryPriceEl = optionBlock.querySelector(".selected_opt_summay h5");
      const summary_price =
        summaryPriceEl && summaryPriceEl.textContent
          ? summaryPriceEl.textContent.trim()
          : "";

      if (checked) {
        const lbl = optionBlock.querySelector(`label[for="${checked.id}"]`);
        selectedText =
          (lbl &&
            lbl.querySelector(".option-title") &&
            lbl.querySelector(".option-title").textContent &&
            lbl.querySelector(".option-title").textContent.trim()) ||
          (lbl && lbl.getAttribute("data-label")) ||
          (checked.value ? String(checked.value).trim() : "") ||
          "";
      } else {
        const p = optionBlock.querySelector(".selected_opt_summay p");
        const baseText = p && p.textContent ? p.textContent.trim() : "";
        const priceWrapped = summary_price ? `(${summary_price})` : "";
        selectedText = [baseText, priceWrapped].filter(Boolean).join(" ").trim();
      }

      if (!selectedText) selectedText = "Select Option";

      // write only the <p> in the matching footer row
      const footerRow = footerRows.find((r) => {
        const h4 = r.querySelector("h4");
        return h4 && h4.textContent && h4.textContent.trim() === heading;
      });
      if (footerRow) {
        const p = footerRow.querySelector("p");
        if (p) p.textContent = selectedText;
      }

      // add price from this block
      const pricedEl = optionBlock.querySelector("[data-option-price]");
      if (pricedEl) total += parsePrice(pricedEl.dataset.optionPrice);
    });

  const totalP = document.querySelector(".customizer_total p");
  if (totalP) {
    totalP.dataset.baseprice = total.toFixed(2);
    if (window.marketInfo.europeContries.includes(window.marketInfo.countryCode) && Number(window.marketInfo.percentEuroIncrease) > 0) {
      total += (total * window.marketInfo.percentEuroIncrease) / 100;
    } else if (window.marketInfo.countryCode !== 'ES'){
      total += (total * window.marketInfo.percentIncrease) / 100;
    }
    totalP.textContent = `€${Math.round(total)}`;
  }

  updateAtcButtonState();
  if (window.matchMedia('(min-width: 990px)').matches) {
    updateElementHeight();
  }
}

function updateAtcButtonState() {
  const buttons = document.querySelectorAll(".atc_btn");
  if (!buttons.length) return;

  const allDone = Array.from(
    document.querySelectorAll(".customizer_optionBlock")
  ).every((block) => {
    const hasRadio = !!block.querySelector('input[type="radio"]:checked');
    const p = block.querySelector(".selected_opt_summay p");
    const text = p && p.textContent ? p.textContent.trim().toLowerCase() : "";
    const hasSummary = text && text !== "select option";
    return hasRadio || hasSummary;
  });

  buttons.forEach((btn) => {
    btn.disabled = !allDone;
    btn.classList.toggle("disabled", !allDone);
    btn.setAttribute("aria-disabled", String(!allDone));
  });
}

document.addEventListener("DOMContentLoaded", updateFooterSummary);
// expose for size modal, etc.
window.updateFooterSummary = updateFooterSummary;

document.addEventListener("click", (e) => {
  const trigger = e.target.closest(".summary_accordion");
  if (!trigger) return;

  const footer = trigger.closest(".customizer_footer");
  if (footer) footer.classList.toggle("active");
});

// =========================
// Helpers (server + cart)
// =========================
function getSelectedSizeTitle() {
  const block =
    document.querySelector('[data-blockname="size__block"]') ||
    document.querySelector('[data-blockName="size__block"]');
  if (!block) return "";
  const checked = block.querySelector('input[name="sizes"]:checked');
  if (!checked) return "";
  const label = checked.closest("label");
  const titleEl = label ? label.querySelector(".option-title") : null;
  const title =
    titleEl && titleEl.textContent ? titleEl.textContent.trim() : "";
  return title || (checked.value ? String(checked.value).trim() : "");
}

function getTotalFromFooterNumber() {
  const el = document.querySelector(".customizer_total p");
  if (!el) return 0;
  let s = el.dataset.baseprice ? el.dataset.baseprice.trim() : "";
  s = s.replace(",", ".").replace(/[^\d.-]/g, "");
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
}


// Extract trailing numeric id from possible GID
function toVariantNumericId(id) {
  if (id == null) return null;
  if (typeof id === "number") return id;
  const m = String(id).match(/(\d+)(?:\D*)$/);
  return m ? Number(m[1]) : null;
}

function calculateWeightFromSize(sizeTitle) {
  if (!sizeTitle) return 0;
  
  // Extract dimensions from size title (format: "210cm X 120cm")
  const dimensions = sizeTitle.toLowerCase().split('x').map(dim => {
    const match = dim.match(/(\d+)/);
    return match ? parseInt(match[1]) : 0;
  });
  
  if (dimensions.length < 2 || dimensions[0] === 0 || dimensions[1] === 0) {
    return 0;
  }
  
  const width = dimensions[0];
  const height = dimensions[1];
  
  // Apply the weight calculation rules
  if (width < 90 && height < 110) return 9;  // Less than 90x110
  
  if (width === 90) {
    if (height <= 110) return 9;
    if (height >= 111 && height <= 150) return 16;
  }
  
  if (width === 110) {
    if (height <= 110) return 12;
    if (height >= 111 && height <= 150) return 16;
  }
  
  if (width === 140) {
    if (height <= 110) return 16;
    if (height >= 111 && height <= 150) return 20;
  }
  
  if (width === 160) {
    if (height <= 110) return 16;
    if (height >= 111 && height <= 150) return 20;
  }
  
  if (width === 180) {
    if (height <= 110) return 20;
    if (height >= 111 && height <= 150) return 22;
  }
  
  if (width === 190) {
    if (height <= 120) return 20;
    if (height >= 121 && height <= 150) return 22;
  }
  
  if (width === 200) {
    if (height <= 120) return 20;
    if (height >= 121 && height <= 150) return 23;
  }
  
  if (width === 210) {
    if (height <= 120) return 20;
    if (height >= 121 && height <= 150) return 24;
  }
  
  // Default fallback for sizes not covered
  return 20;
}

async function createVariantOnServer(payload) {
  const url =
    (window.general && window.general.createVariantEndpoint) ||
    "https://coffeneti-app.vercel.app/create-variant";

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  let data;
  try {
    data = await res.json();
  } catch (_) {
    data = null;
  }

  if (!res.ok) {
    const msg =
      (data && (data.message || data.description)) || "HTTP " + res.status;
    throw new Error(msg);
  }
  return data;
}

async function addVariantToCart(variantId, quantity, properties) {
  const payload = {
    items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }],
  };
  if (properties && typeof properties === "object") {
    payload.items[0].properties = properties;
  }

  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });

  let data;
  try {
    data = await res.json();
  } catch (_) {
    data = { raw: await res.text() };
  }

  if (!res.ok) {
    const msg =
      (data && (data.description || data.message)) || "Failed to add to cart";
    throw new Error(msg);
  }
  return data;
}

const DELAY_BEFORE_CART_MS = 8000;
function delay(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

function showCartErrorPopup() {
  const overlay = document.createElement("div");
  overlay.className = "image-popup-overlay active";

  const wrap = document.createElement("div");
  wrap.className = "image-popup-wrapper";

  const closeBtn = document.createElement("button");
  closeBtn.className = "image-popup-close";
  closeBtn.innerHTML = "&times;";

  const card = document.createElement("div");
  card.setAttribute(
    "style",
    "max-width:520px;background:#fff;padding:20px 24px;border-radius:8px;" +
      "box-shadow:0 2px 20px rgba(0,0,0,.25);font-size:16px;line-height:1.5;text-align:center;"
  );
  card.innerHTML = `
    <h3 style="margin:0 0 8px;font-size:18px;">Lo sentimos</h3>
    <p style="margin:0;">We are unable to add item to the cart at the moment,<br>
    please contact us on <strong>56573738</strong>.</p>
  `;

  const close = () => {
    overlay.classList.remove("active");
    document.body.style.overflow = "";
    setTimeout(() => overlay.remove(), 250);
  };

  closeBtn.addEventListener("click", close);
  overlay.addEventListener("click", (ev) => {
    if (ev.target === overlay) close();
  });

  wrap.appendChild(closeBtn);
  wrap.appendChild(card);
  overlay.appendChild(wrap);
  document.body.appendChild(overlay);
  document.body.style.overflow = "hidden";
}

// ==========================================
// ATC click handler
// ==========================================
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".atc_btn");
  if (!btn) return;
  e.preventDefault();

  if (window.__atcBusy) return;
  if (btn.disabled) return;
  window.__atcBusy = true;

  // disable all ATC buttons while processing (spinner only on the clicked one)
  const allAtcButtons = document.querySelectorAll(".atc_btn");
  allAtcButtons.forEach((b) => {
    b.disabled = true;
    b.classList.add("disabled");
    b.setAttribute("aria-disabled", "true");
  });

  const label = btn.querySelector(".atc_label");
  const spinner = btn.querySelector(".loading__spinner");
  const icon = btn.querySelector("img");
  const originalText = label && label.textContent ? label.textContent : "";
  const originalIconDisplay = icon ? icon.style.display : "none";

  btn.disabled = true;
  if (label) label.textContent = "";
  if (spinner) spinner.classList.remove("hidden");
  if (icon) icon.style.display = "none";

  let success = false;
  try {
    // keep summary fresh
    if (typeof window.updateFooterSummary === "function") {
      window.updateFooterSummary();
    }

    // Build line-item properties from footer
    const props = {};
    const missing = [];
    document
      .querySelectorAll(
        ".customizer_summary_item .sum_optionTitle:not(.customizer_total)"
      )
      .forEach((row) => {
        const h4 = row.querySelector("h4");
        const p = row.querySelector("p");
        const title = h4 && h4.textContent ? h4.textContent.trim() : "";
        const value = p && p.textContent ? p.textContent.trim() : "";
        if (!value || /select option/i.test(value)) missing.push(title);
        else props[title] = value;
      });

    if (missing.length) {
      alert("Please select: " + missing.join(", "));
      return;
    }

    // Variant title = selected size
    const sizeTitle = getSelectedSizeTitle();
    if (!sizeTitle) {
      alert("Please select a size.");
      return;
    }

    // Price to send (what shopper sees)
    const totalNumber = getTotalFromFooterNumber();
    if (!totalNumber || totalNumber <= 0) {
      alert("Calculated price is missing.");
      return;
    }

    // // Also store visible price on the line item
    // props["Price"] = totalNumber.toFixed(2);

    const weight = calculateWeightFromSize(sizeTitle);
    console.log(weight);

    // Create-variant payload for your server
    const payload = {
      productId: window.general ? window.general.productId : undefined,
      title: sizeTitle,
      price: Number(totalNumber),
      weight: weight,
      profileId: window.general ? window.general.profileId : undefined,
    };

    // 1) Create variant on your server
    const created = await createVariantOnServer(payload);
    const rawId =
      (created && created.variant && created.variant.id) ||
      (created && created.id) ||
      (created && created.variant_id) ||
      null;
    const newVariantId = toVariantNumericId(rawId);

    if (!newVariantId) {
      showCartErrorPopup();
      return;
    }

    // 2) Wait 4 seconds before adding to cart
    await delay(DELAY_BEFORE_CART_MS);

    // 3) Add newly-created variant to cart
    try {
      await addVariantToCart(newVariantId, 1, props);
    } catch (_) {
      showCartErrorPopup();
      return;
    }

    success = true;
    window.location.href = "/cart";
  } catch (_) {
    showCartErrorPopup();
  } finally {
    if (!success) {
      window.__atcBusy = false;
      updateAtcButtonState();

      if (label) label.textContent = originalText;
      if (spinner) spinner.classList.add("hidden");
      if (icon) icon.style.display = originalIconDisplay || "";
    }
  }
});
